module.exports = __webpack_public_path__ + "static/shopify_2-0045a9a5c89233cdcd088e3a2cf2561f.png";